
import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Step } from '../components/Stepper';

interface StepperContextType {
  steps: Step[];
  setSteps: (steps: Step[]) => void;
  updateStep: (stepId: string, newState: Step['state']) => void;
  showStepper: boolean;
  setShowStepper: (show: boolean) => void;
  resetStepper: () => void;
}

const StepperContext = createContext<StepperContextType | undefined>(undefined);

export const useStepperContext = () => {
  const context = useContext(StepperContext);
  if (!context) {
    throw new Error('useStepperContext must be used within a StepperProvider');
  }
  return context;
};

interface StepperProviderProps {
  children: ReactNode;
}

export const StepperProvider: React.FC<StepperProviderProps> = ({ children }) => {
  const [steps, setSteps] = useState<Step[]>([]);
  const [showStepper, setShowStepper] = useState(false);

  const updateStep = (stepId: string, newState: Step['state']) => {
    setSteps(prevSteps => 
      prevSteps.map(step => 
        step.id === stepId ? { ...step, state: newState } : step
      )
    );
  };

  const resetStepper = () => {
    setSteps([]);
    setShowStepper(false);
  };

  return (
    <StepperContext.Provider value={{
      steps,
      setSteps,
      updateStep,
      showStepper,
      setShowStepper,
      resetStepper
    }}>
      {children}
    </StepperContext.Provider>
  );
};
